import { useMemo } from 'react';
import { Box, Container, styled, Tab, Tabs } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useActiveLocation } from '@common/hooks/use-active-location.hook';

export interface PageTabProps {
  label: string;
  to: string;
}

export interface PageTabsProps {
  tabs: PageTabProps[];
}

const PageTabsContainer = styled(Box)(({ theme }) => ({
  borderBottom: 1,
  borderColor: 'divider',
  padding: `${theme.spacing(0, 3, 2)}`,
}));

export function PageTabs({ tabs }: PageTabsProps) {
  const isActive = useActiveLocation();

  const activeTab = useMemo(() => {
    const index = tabs.findIndex((tab) => isActive(tab.to));
    return index > -1 ? index : 0;
  }, [isActive, tabs]);

  return (
    <PageTabsContainer>
      <Container maxWidth={false}>
        <Tabs value={activeTab}>
          {tabs.map((tab) => (
            <PageTab key={tab.to} {...tab} />
          ))}
        </Tabs>
      </Container>
    </PageTabsContainer>
  );
}

function PageTab(props: PageTabProps) {
  return <Tab data-trigger={`${props.label} Tab Clicked`} component={RouterLink} {...props} />;
}
